import React, { useEffect, useState } from 'react';
import {
  Modal,
  Header,
  Form,
  Input,
  Button,
  Label,
  Dropdown,
  Select,
} from 'semantic-ui-react';
import { getDemoModelList } from '../../../apis/demo.api';

const DemoDeviceFormModal = ({ open, onClose, onSubmit, initialValues }) => {
  const [models, setModels] = useState([]);
  const [macPrefix, setMacPrefix] = useState(
    macPrefixes.find((p) => initialValues.macAddress?.startsWith(p)) ||
      macPrefixes[0]
  );
  const [macPostfix, setMacPostfix] = useState(
    initialValues.macAddress?.replace(`${macPrefix}:`, '') || ''
  );
  const [model, setModel] = useState(initialValues.model || '');
  const [memo, setMemo] = useState(initialValues.memo || '');
  const [loading, setLoading] = useState(false);

  const isMacAddressValid = /^([0-9A-Fa-f]{2}[:-])([0-9A-Fa-f]{2})$/.test(
    macPostfix
  );
  const showMacAddressError = !isMacAddressValid && macPostfix?.length > 0;

  const isVaild = isMacAddressValid && model;

  const handleSubmit = async () => {
    if (!isVaild) return;
    setLoading(true);
    await onSubmit({ macAddress: `${macPrefix}:${macPostfix}`, model, memo });
    setLoading(false);
  };

  useEffect(() => {
    getDemoModelList().then(setModels);
  }, []);

  return (
    <Modal open={open} onClose={onClose} size="small">
      <Modal.Header>
        <Header as="h3">
          {initialValues.macAddress ? 'Edit' : 'Add'} Device
        </Header>
      </Modal.Header>

      <Modal.Content>
        <Form>
          {/* MAC Address */}
          <Form.Field error={showMacAddressError}>
            <Label>MAC Address</Label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Select
                placeholder="Select MAC Prefix"
                options={macPrefixes.map((m) => ({
                  key: m,
                  text: m,
                  value: m,
                }))}
                value={macPrefix}
                onChange={(e, { value }) => setMacPrefix(value)}
              />
              <Input
                placeholder="Enter MAC Address"
                value={macPostfix}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 5) {
                    setMacPostfix(value);
                  }
                }}
              />
            </div>
            {showMacAddressError && (
              <Label basic color="red" pointing>
                MAC Address must be like 00:00:00:00:00:00
              </Label>
            )}
          </Form.Field>

          {/* Model Dropdown */}
          <Form.Field>
            <Label>Model</Label>
            <Dropdown
              placeholder="Select Model"
              fluid
              search
              selection
              value={model}
              onChange={(e, { value }) => setModel(value)}
              options={models.map((m) => ({
                key: m,
                text: m,
                value: m,
              }))}
            />
          </Form.Field>

          {/* Memo */}
          <Form.Field>
            <Label>Memo</Label>
            <Input
              placeholder="Enter Memo"
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
            />
          </Form.Field>

          {/* Submit Button */}
          <Form.Field style={{ textAlign: 'right' }}>
            <Button
              primary
              onClick={handleSubmit}
              disabled={!isVaild || loading}
              loading={loading}
              style={{
                height: 40,
                width: 100,
                position: 'relative',
                left: 0,
              }}
            >
              Submit
            </Button>
          </Form.Field>
        </Form>
      </Modal.Content>
    </Modal>
  );
};

export default DemoDeviceFormModal;

const macPrefixes = ['00:23:f2:00', 'd8:00:93:00', 'd8:00:93:08'];
